export default ({ request }) => ({
    ecomAmzFileUploadApi(data = {}) {
        return request({
            url: '/ecom/amz/files/upload',
            method: 'POST',
            data,
        })
    },
    ecomAmzFileListApi(data = {}) {
        return request({
            url: '/ecom/amz/files/list',
            method: 'POST',
            data,
        })
    },
    ecomAmzFileDelApi(data = {}) {
        return request({
            url: '/ecom/amz/files/del',
            method: 'POST',
            data,
        })
    },
})
